// extracted by mini-css-extract-plugin
export var layout = "Events-module--layout--99b8a";
export var description = "Events-module--description--42a66";
export var items = "Events-module--items--4bdb3";
export var item = "Events-module--item--b352c";
export var schedule = "Events-module--schedule--2a250";
export var date = "Events-module--date--4455f";
export var time = "Events-module--time--7b85f";
export var label = "Events-module--label--222e0";
export var content = "Events-module--content--67cbf";
export var button = "Events-module--button--4e948";
export var text = "Events-module--text--6f0a6";
export var itemTitle = "Events-module--itemTitle--03a7a";
export var itemDescription = "Events-module--itemDescription--c587b";